import { Schema } from "prosemirror-model";

import { marks } from "./marks";
import { nodes } from "./nodes";

export { getHeadingAnchorTag } from "./nodes/heading";

export { BULLET_CHARS, DEFAULT_BULLET, DEFAULT_INDENT } from "./nodes/list_item";

// Re-export suggest-changes utilities to ensure all packages use the same instance
export {
	applySuggestion,
	applySuggestions,
	disableSuggestChanges,
	enableSuggestChanges,
	isSuggestChangesEnabled,
	revertSuggestion,
	revertSuggestions,
	transformToSuggestionTransaction,
} from "@handlewithcare/prosemirror-suggest-changes";

export * from "./buildAcceptedProjectionWithMapping";

// The schema is the same as prosemirror's Basic Schema, with the exception that the image node is removed.
// Basic Schema: https://prosemirror.net/docs/ref/#schema-basic
export const schema = new Schema({
	nodes,
	marks,
});
